import React, { Component } from 'react'
import styles from '../style.module.less'
import ArriveGift from '../ArriveGift'
import ConsultGift from '../ConsultGift'
import ShopPromise from '../ShopPromise'
import ListBack from '../ListBack'
import HotTag from '../HotTag'
import { observer } from 'mobx-react'
import store from './store'
import { Tabs } from 'hljd'
import { HeaderView } from '@merchant-backend/common-components'
import { isStoreAccount } from '@util'

const TabPane = Tabs.TabPane

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { key }
      }
    } = this.props
    if (key) {
      store.key = key + ''

      store.changeTabKey(key)
    }
  }

  componentDidMount() {
    store.getTabInfo()
    store.getGift(1)
  }

  componentWillUnmount() {
    store.key = '1'
    store.changeTabKey('1')
  }

  render() {
    const { key } = store
    return (
      <HeaderView contentStyle={{ padding: 0 }}>
        <div className={styles.wrap}>
          <Tabs activeKey={key} onChange={store.changeTabKey}>
            <TabPane tab="到店礼" key="1">
              <ArriveGift />
            </TabPane>
            <TabPane tab="咨询礼" key="32">
              <ConsultGift />
            </TabPane>
            {!isStoreAccount() && (
              <TabPane tab="商家承诺" key="5">
                <ShopPromise />
              </TabPane>
            )}
            {!isStoreAccount() && (
              <TabPane tab="订单可退" key="6">
                <ListBack />
              </TabPane>
            )}

            <TabPane tab="套餐热标" key="17">
              <HotTag />
            </TabPane>
          </Tabs>
        </div>
      </HeaderView>
    )
  }
}
